"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Icon2 = require("../../../Icon");
var _Icon3 = _interopRequireDefault(_Icon2);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
var IconNewspaperReadMan = /*#__PURE__*/
function (_Icon) {
  _inherits(IconNewspaperReadMan, _Icon);
  function IconNewspaperReadMan(props) {
    var _this;
    _classCallCheck(this, IconNewspaperReadMan);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(IconNewspaperReadMan).call(this, props));
    _this.name = 'IconNewspaperReadMan';
    _this.icon = _react2.default.createElement("svg", {
      viewBox: "0 0 24 24",
      width: "1em",
      height: "1em",
      focusable: "false",
      "aria-hidden": "true",
      role: "presentation"
    }, _react2.default.createElement("g", {
      className: "newspaper-read-man_svg__group0"
    }, _react2.default.createElement("path", {
      className: "newspaper-read-man_svg__path0",
      d: "M16 7.023c-2.692 0-3.565-.759-4-1.378-.443.627-1.321 1.378-4 1.378a.5.5 0 010-1c2.622 0 3.058-.731 3.347-1.214.086-.143.174-.291.299-.417a.5.5 0 01.708 0c.125.125.214.273.299.416.289.484.725 1.215 3.347 1.215a.5.5 0 010 1z"
    }), _react2.default.createElement("path", {
      className: "newspaper-read-man_svg__path1",
      d: "M17.312 9a.499.499 0 01-.496-.57l.465-3.3c.01-.212.027-1.428-.873-2.418-.881-.97-2.365-1.462-4.408-1.462-2.047 0-3.533.494-4.414 1.468-.976 1.078-.867 2.414-.866 2.427l.475 3.262a.5.5 0 01-.99.144l-.478-3.285c-.008-.083-.168-1.799 1.117-3.219C7.924.854 9.658.25 12 .25c2.342 0 4.076.604 5.156 1.797 1.283 1.418 1.127 3.125 1.12 3.197l-.469 3.326a.502.502 0 01-.495.43z"
    }), _react2.default.createElement("path", {
      className: "newspaper-read-man_svg__path2",
      d: "M11.111 9.25a.5.5 0 01-.496-.441 2.34 2.34 0 00-.172-.005l-.219.001-.221-.001c-.078 0-.133.002-.173.004a.5.5 0 01-.997-.058c0-.28.085-.506.252-.672.254-.252.589-.273.911-.273l.226.001.222-.001c.323 0 .66.021.913.272.168.166.253.392.253.673a.499.499 0 01-.499.5z"
    }), _react2.default.createElement("path", {
      className: "newspaper-read-man_svg__path3",
      d: "M14.667 9.25a.502.502 0 01-.497-.441 2.616 2.616 0 00-.178-.004h-.441c-.074 0-.127.002-.166.005a.5.5 0 01-.997-.059c0-.28.085-.506.253-.673.253-.251.604-.273.912-.273l.226.001.221-.001c.324 0 .661.021.915.272.168.166.253.392.253.673a.502.502 0 01-.501.5z"
    }), _react2.default.createElement("path", {
      className: "newspaper-read-man_svg__path4",
      d: "M12 23.75a.472.472 0 01-.128-.017l-8.753-2.304A1.499 1.499 0 012 19.979v-3.352c-1.257-.318-2-1.195-2-2.377s.743-2.059 2-2.377v-1.259a1.495 1.495 0 011.95-1.43L12 11.726l8.05-2.541a1.51 1.51 0 011.144.1A1.495 1.495 0 0122 10.614v1.259c1.257.318 2 1.195 2 2.377s-.743 2.059-2 2.377v3.352a1.5 1.5 0 01-1.119 1.45l-8.754 2.304a.554.554 0 01-.124.017H12zm-9-3.771c0 .227.154.426.373.484l8.127 2.139v-9.985l-7.851-2.479a.505.505 0 00-.649.477v1.135c.551 0 1 .449 1 1v3c0 .552-.449 1-1 1v3.229zm9.5 2.623l8.126-2.139a.502.502 0 00.374-.484V16.75a1 1 0 01-1-1v-3c0-.551.448-1 1-1v-1.136a.495.495 0 00-.499-.5.517.517 0 00-.151.023l-7.85 2.478v9.987zM21 15.75c.334 0 2-.072 2-1.5 0-1.427-1.665-1.5-2-1.5v3zm-18-3c-.334 0-2 .072-2 1.5s1.666 1.5 2 1.5v-3z"
    })));
    return _this;
  }
  return IconNewspaperReadMan;
}(_Icon3.default);
exports.default = IconNewspaperReadMan;